/*
 *  Bootstrap Nice Select Catalan (Spain) Translation
 *  Author: Kevin Gostomski <kevingostomski2001@gmail.com> 
*/

const localisation = {
    locales: []
}

localisation.locales['ca-ES'] = localisation.locales['ca'] = {
    formatSearch() {
        return "Buscant...";
    },
    formatHelpForTagging() {
        return "Per crear etiquetes pròpies, centreu el camp d'entrada i premeu 'Enter' o ',' o 'Barra espaiadora' per afegir-lo a la llista";
    }
}

export default localisation;